import React from "react";
import { STATES, KINDS, QUALIFICATIONS, hoursLabel, dayHoursLabel, deductedSeconds } from "./HoursDetail.jsx";
import { periodDays, periodTotal } from "./hoursSummary.js";
import { periodTitle } from "../../../utils/consolidationOverview.js";
import { clockLabel, workDateLabel } from "../../../utils/consolidationPresentation.js";
import { consolidationPeriodMode } from "../../../utils/consolidationViewStorage.js";

// En-tête d'une page imprimée : « Semaine du 25 au 31 octobre ».
export const printedPeriod = data => periodTitle(consolidationPeriodMode(data.from_date, data.to_date), data.from_date, data.to_date);

export function HoursDayRows({ row, day, timezone }) {
  // Heure seule sous la ligne de la journée ; une heure du lendemain porte « J+1 ».
  const local = value => value ? clockLabel(value, timezone, day) : "À renseigner";
  const sources = row?.sources || [];
  return <>
    <tr className="hours-summary-day"><th scope="row">{workDateLabel(day)}</th><td colSpan={3}></td><td>{dayHoursLabel(row) || "Durée non calculable"}</td><td>{row ? row.status_label || STATES[row.state] : "Aucune entrée"}</td></tr>
    {sources.map(source => <tr key={source.id}>
      <td>{source.kind === "supplement" ? QUALIFICATIONS[source.qualification || "legacy"] : KINDS[source.kind]}{source.reason ? <p>{source.reason}</p> : null}{source.included_in_service ? <p>Inclus dans le service · non ajouté au total</p> : null}</td>
      <td>{local(source.start_at)}</td><td>{local(source.end_at)}</td>
      <td>{hoursLabel(deductedSeconds(source)) || "0 h 00"}</td><td>{hoursLabel(source.net_seconds) || "Durée non calculable"}</td><td>{STATES[source.status] || ""}</td>
    </tr>)}
    {row && (row.remaining_drafts || row.remaining_anomalies || row.issues?.length || row.warnings?.length) ? <tr><td colSpan={6} className="text-amber-800">
      {row.remaining_drafts ? <p>{row.remaining_drafts} brouillon(s) restant(s).</p> : null}
      {row.remaining_anomalies ? <p>Anomalie ou horaires incomplets.</p> : null}
      {[...(row.issues || []), ...(row.warnings || [])].map((message, index) => <p key={index}>{message}</p>)}
    </td></tr> : null}
  </>;
}

export function HoursSummaryTable({ children }) {
  return <div className="hours-summary-scroll"><table className="hours-summary-table" aria-label="Résumé des heures par journée">
    <thead><tr>{["Journée / activité", "Début", "Fin", "Dîner et pauses non payées", "Heures nettes", "Statut"].map(label => <th scope="col" key={label}>{label}</th>)}</tr></thead>
    <tbody>{children}</tbody>
  </table></div>;
}

export default function HoursSummary({ employee, data }) {
  return <section aria-label={`Résumé des heures · ${employee.name}`} className="hours-summary grid min-w-0 gap-2 rounded-[4px] border border-slate-300 bg-white p-3 text-xs">
    <header><h3 className="text-sm font-semibold">{employee.name}</h3><p>{printedPeriod(data)}</p></header>
    <HoursSummaryTable>{periodDays(data.from_date, data.to_date).map(day => <HoursDayRows key={day} day={day} row={employee.days.get(day)} timezone={data.timezone} />)}</HoursSummaryTable>
    <p className="font-semibold">Total de la période : {dayHoursLabel(periodTotal(employee))} · Dont compléments non facturables : {hoursLabel(employee.nonBillable)}</p>
    <p>Heures travaillées enregistrées · fin − début − dîner − pauses non payées (une pause payée reste comptée). Ces totaux ne sont ni les heures facturables ni un calcul de paie.</p>
  </section>;
}
